import { Component } from '@angular/core';
import { ADataPreviewSettings } from '../common/adatapreview.settings';

@Component({
    selector: 'container-csv-settings',
    templateUrl: '../../base.list.settings.html'
})
export class ContainerCSVSettings extends ADataPreviewSettings {
    getTypeName(): string {
        return 'evidanza.MiddleWare.Shared.Container.ContainerCSV';
    }

    getDBTypes(): number[][] {
        return [[256]]; // DataSourceRead
    }

    getResourceBase(): number {
        return 1;
    }

    static GetSettingsEntry() {
        return {
            Caption: '@@ContainerCSV',
            ID: 'containercsv',
            Icon: 'filetype-csv',
            Index: 30,
            Parent: 'relational',
            Security: {
                Name: 'evidanza.MiddleWare.Shared.Security.RelationalContainerRight',
                Value: 16
            },
            Content: ContainerCSVSettings
        }
    }
}